import { buildTestId } from '~/utils/buildTestId';

export const CUSTOMER_ADMIN_DEPARTMENTS_TABS = {
  byIDN: 0,
  all: 1,
} as const;

const CUSTOMER_ADMIN_DEPARTMENTS_TABS_LABEL: Record<
  (typeof CUSTOMER_ADMIN_DEPARTMENTS_TABS)[keyof typeof CUSTOMER_ADMIN_DEPARTMENTS_TABS],
  string
> = {
  [CUSTOMER_ADMIN_DEPARTMENTS_TABS.byIDN]: 'By IDN',
  [CUSTOMER_ADMIN_DEPARTMENTS_TABS.all]: 'All Departments',
} as const;

type CustomerAdminDepartmentsTabsKey =
  keyof typeof CUSTOMER_ADMIN_DEPARTMENTS_TABS;
export type CustomerAdminDepartmentsTabsValue =
  (typeof CUSTOMER_ADMIN_DEPARTMENTS_TABS)[keyof typeof CUSTOMER_ADMIN_DEPARTMENTS_TABS];

export const CustomerAdminDepartmentTabsConfig = (testID: string) =>
  (
    Object.keys(
      CUSTOMER_ADMIN_DEPARTMENTS_TABS,
    ) as CustomerAdminDepartmentsTabsKey[]
  ).map((key) => {
    const label =
      CUSTOMER_ADMIN_DEPARTMENTS_TABS_LABEL[
        CUSTOMER_ADMIN_DEPARTMENTS_TABS[key]
      ];

    return {
      label,
      'aria-label': label,
      testID: buildTestId({ testID, suffix: ['tab', label] }),
    };
  });
